module.exports = __webpack_public_path__ + "img/logo.ae562c7d.png";